import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './plugins/axios';
import './plugins/acl';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n';
import {AuthAction} from "@/store/auth/types";

Vue.config.productionTip = false;

store.dispatch(`auth/${AuthAction.LOAD_USER}`).finally(() => {
  new Vue({
    store,
    router,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app');
});
